import { useState, useEffect } from 'react';

/**
 * Хук для debounce значення
 * @param {any} value - значення для debounce
 * @param {number} delay - затримка в мілісекундах
 * @returns {any} - debounced значення
 */
export const useDebounce = (value, delay = 300) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};

export default useDebounce;

